import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AcceptInvite from "@/pages/AcceptInvite";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Dashboard from "@/pages/Dashboard";
import SuperAdmin from "@/pages/SuperAdmin";
import ManageTeam from "@/pages/manage/ManageTeam";
import TeamHub from "@/pages/TeamHub";
import PlayerPortal from "@/pages/PlayerPortal";
import PaymentResult from "@/pages/PaymentResult";
import CmsPage from "@/pages/CmsPage";
import { SiteProvider } from "@/lib/seo";

function App() {
  return (
    <div className="App">
      <SiteProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/invite/:token" element={<AcceptInvite />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute superOnly><SuperAdmin /></ProtectedRoute>} />
            <Route path="/manage/:teamId" element={<ProtectedRoute><ManageTeam /></ProtectedRoute>} />
            <Route path="/t/:slug" element={<TeamHub />} />
            <Route path="/t/:slug/:page" element={<TeamHub />} />
            <Route path="/t/:slug/players" element={<PlayerPortal />} />
            <Route path="/payment/success" element={<PaymentResult success />} />
            <Route path="/payment/cancel" element={<PaymentResult />} />
            <Route path="/billing/success" element={<PaymentResult success billing />} />
            <Route path="/p/:slug" element={<CmsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" richColors />
      </AuthProvider>
      </SiteProvider>
    </div>
  );
}

export default App;
